<template>
    <ul class="mainmenu">
        <li v-for="(item, index) in navItems"
            :class="[item.hasDropdown ? 'has-droupdown has-menu-child-item' : '', item.megamenu ? 'with-megamenu' : '']"
            :key="`nav-item-${index}`">
            <router-link :to="item.link" class="nav-link its_new">
                {{ item.title }}
            </router-link>
            <ul v-if="item.hasDropdown" class="submenu">
                <li v-for="(subMenuItem, subMenuIndex) in item.dropdownItems"
                    :key="`sub-menu-item-${subMenuIndex}`">
                    <router-link :to="subMenuItem.link" :class="subMenuItem.class">
                        {{ subMenuItem.title }}
                        <i v-if="subMenuItem.class !== 'live-expo'" :class="`feather-${subMenuItem.icon}`"/>
                    </router-link>
                </li>
            </ul>
            <div v-if="item.megamenu" class="rn-megamenu">
                <div class="wrapper">
                    <div class="row row--0">
                        <div v-for="(megamenuItem, megamenuIndex) in item.megaMenuItems"
                             :key="`mega-menu-item-${megamenuIndex}`"
                             class="col-lg-3 single-mega-item">
                            <ul class="mega-menu-item">
                                <li v-for="(megamenuSubItem, megamenuSubIndex) in megamenuItem.items"
                                    :key="`mega-submenu-item-${megamenuSubIndex}`">
                                    <router-link :to="megamenuSubItem.link">
                                        {{ megamenuSubItem.title }} <i :class="`feather-${megamenuSubItem.icon}`"/>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'Nav',
    data() {
        return {
            navItems: [
                {
                    link: '/',
                    title: 'Home',
                    hasDropdown: false,
                    megamenu: false,
                },
                {
                    link: '/about',
                    title: 'About Us',
                    hasDropdown: false,
                    megamenu: false,
                },
                {
                    link: '#',
                    title: 'Services',
                    hasDropdown: true,
                    megamenu: false,
                    dropdownItems: [
                        {link: '/explore-01', title: 'Explore Filter', icon: 'fast-forward'},
                        {link: '/explore-02', title: 'Explore Isotop', icon: 'fast-forward'},
                        {link: '/explore-03', title: 'Explore Carousel', icon: 'fast-forward'},
                        {link: '/explore-04', title: 'Explore Simple', icon: 'fast-forward'},
                        {link: '/explore-05', title: 'Explore Place Bid', icon: 'fast-forward'},
                        {link: '/explore-06', title: 'Place Bid With Filter', icon: 'fast-forward'},
                        {link: '/explore-07', title: 'Place Bid With Isotop', icon: 'fast-forward'},
                        {link: '/explore-08', title: 'Place Bid With Carousel', icon: 'fast-forward'},
                        {link: '/explore-09', title: 'Explore Style List', icon: 'fast-forward'},
                        {link: '/explore-10', title: 'Explore List Col-Two', icon: 'fast-forward'},
                        {link: '/explore-14', title: 'Explore Left Filter', icon: 'fast-forward'},
                        {link: '/explore-11', title: 'Live Explore', icon: 'fast-forward', class: 'live-expo'},
                        {link: '/explore-12', title: 'Live Explore Carousel', icon: 'fast-forward', class: 'live-expo'},
                        {link: '/explore-13', title: 'Live With Place Bid', icon: 'fast-forward', class: 'live-expo'},
                    ]
                },
                {
                    link: '/contact',
                    title: 'Contact',
                    hasDropdown: false,
                    megamenu: false,
                }
            ]
        }
    }
}
</script>